module.exports = __webpack_public_path__ + "img/save.31a1c713.svg";